import script from "./background-remove.vue?vue&type=script&setup=true&lang=js"
export * from "./background-remove.vue?vue&type=script&setup=true&lang=js"

import "./background-remove.vue?vue&type=style&index=0&id=43b8203e&lang=less"

const __exports__ = script;

export default __exports__